import { ApolloError, useQuery } from "@apollo/client";
import { GET_AUTOREQ_TRACES } from "graphql/queries";
import { QueryInfo, IdentifiableTraceInfo, TraceInfo } from "types";

function normalizeCorrelationId(correlationId?: string) {
    return correlationId?.trim().replace("autorequest_", "");
}

export function useAutorequestTraces(
    queryInfo?: QueryInfo
): [IdentifiableTraceInfo[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<{ trace: TraceInfo[] }>(GET_AUTOREQ_TRACES, {
        variables: {
            queryParams: {
                correlationId: normalizeCorrelationId(queryInfo?.correlationId),
                filter: queryInfo?.filter,
                page: queryInfo?.page ? { name: "page", value: queryInfo.page } : undefined,
                admin: !!queryInfo?.isAdmin
            }
        },
        errorPolicy: "all",
        skip: !queryInfo
    });

    if (data && !Array.isArray(data.trace)) {
        console.warn("trace warning", data.trace);
    }
    let dataWithId: IdentifiableTraceInfo[] = [];
    // ag grid row need id's to be identifiable
    if (data && Array.isArray(data.trace)) {
        let id = 1;
        dataWithId = data.trace.map((t) => ({ id: id++, ...t }));
    }

    return [dataWithId, loading, error];
}
